import {IUser} from 'app/core/user/user.model';
import {IBaseEntity} from 'app/blocks/model/base-entity.model';

export enum ReindexStatus {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}

export interface IReindexRequest extends IBaseEntity {
    id?: number;
    entityNames?: string;
    status?: ReindexStatus;
    startedAt?: string;
    completedAt?: string;
    totalEntitiesCount?: number;
    completedEntitiesCount?: number;
    failedEntitiesCount?: number;
    processedRowsCount?: number;
    totalRowsCount?: number;
    errorMessage?: string;
    triggeredBy?: number;
    triggeredByName?: string;
    createdAt?: string;
}

export interface ReindexStats {
    pending: number;
    inProgress: number;
    completed: number;
    failed: number;
    total: number;
}

export class ReindexRequest implements IReindexRequest {
    id?: number;
    entityNames?: string;
    status?: ReindexStatus;
    startedAt?: string;
    completedAt?: string;
    totalEntitiesCount?: number;
    completedEntitiesCount?: number;
    failedEntitiesCount?: number;
    processedRowsCount?: number;
    totalRowsCount?: number;
    errorMessage?: string;
    triggeredBy?: number;
    triggeredByName?: string;
    createdAt?: string;

    constructor(reindexRequest?: any) {
        if (reindexRequest) {
            this.id = reindexRequest.id;
            this.entityNames = reindexRequest.entityNames;
            this.status = reindexRequest.status;
            this.startedAt = reindexRequest.startedAt;
            this.completedAt = reindexRequest.completedAt;
            this.totalEntitiesCount = reindexRequest.totalEntitiesCount;
            this.completedEntitiesCount = reindexRequest.completedEntitiesCount;
            this.failedEntitiesCount = reindexRequest.failedEntitiesCount;
            this.processedRowsCount = reindexRequest.processedRowsCount;
            this.totalRowsCount = reindexRequest.totalRowsCount;
            this.errorMessage = reindexRequest.errorMessage;
            this.triggeredBy = reindexRequest.triggeredBy;
            this.triggeredByName = reindexRequest.triggeredByName;
            this.createdAt = reindexRequest.createdAt;
        }
    }

    discriminator?: any;

    toFormObject() {
        throw new Error('Method not implemented.');
    }

    clone(): IBaseEntity {
        return new ReindexRequest(this);
    }

    getProgressPercentage(): number {
        if (this.totalRowsCount && this.totalRowsCount > 0) {
            return Math.round(((this.processedRowsCount || 0) / this.totalRowsCount) * 100);
        }
        if (!this.totalEntitiesCount || this.totalEntitiesCount === 0) {
            return 0;
        }
        return Math.round(((this.completedEntitiesCount || 0) / this.totalEntitiesCount) * 100);
    }

    isInProgress(): boolean {
        return this.status === ReindexStatus.IN_PROGRESS;
    }
}
